import React, { useState, createContext } from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import * as Icon from 'react-icons/md';

const ToastContext = createContext({
    showToast: (payload: TypeToast) => { },
    hideToast: () => { },
});

export interface TypeToast {
    type: "success" | "faild" | "",
    message: string
}

const ToastContextProvider = ({ children }) => {
    const [isShow, setToastVisible] = useState(false);
    const [data, setData] = useState<TypeToast>({ type: "", message: "" });

    const showToast = (payload: TypeToast) => {
        setData(payload);
        setToastVisible(true);
    }

    const hideToast = () => {
        setToastVisible(false);
    }

    return (
        <ToastContext.Provider value={{
            showToast,
            hideToast
        }}>
            <ToastContainer className="p-3" position={"top-end"} style={{ zIndex: 99 }}>
                <Toast show={isShow} onClose={hideToast}>
                    <Toast.Header>
                        {data.type === "success" ?
                            <>
                                <Icon.MdInfo size={24} />
                                <strong className="me-auto">Success</strong>
                            </>
                            :
                            <>
                                <Icon.MdError size={24} />
                                <strong className="me-auto">Error</strong>
                            </>
                        }
                        <small>1 mins ago</small>
                    </Toast.Header>
                    <Toast.Body>{data.message}</Toast.Body>
                </Toast>
            </ToastContainer>
            {children}
        </ToastContext.Provider>
    );
}

export { ToastContextProvider };
export default ToastContext;
